var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.menuType,attrs:{"id":"app-container"}},[_c('crm-toolbar',{staticClass:"flex-no-grow"}),_c('crm-sidebar'),_c('main',[_c('div',{staticClass:"container-fluid"},[_c('router-view',{key:_vm.$route.path})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }